"use client"

import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"
import { Trash2 } from "lucide-react"

interface ModalFooterProps {
  onDelete?: () => void
  onSave?: () => void
  appointmentId?: string | number
  isSaving?: boolean
  disableSave?: boolean
}

export function ModalFooter({ onDelete, onSave, appointmentId, isSaving, disableSave }: ModalFooterProps) {
  const { t } = useTranslation()
  return (
    <div className="border-t p-3 flex justify-between items-center">
      <div className="flex items-center">
        <Button variant="outline" size="sm" className="text-xs flex items-center" onClick={onDelete}>
          <Trash2 className="w-3.5 h-3.5 mr-1" />
          {t("common.delete", "Delete")}
        </Button>
        {appointmentId && (
          <span className="ml-4 text-xs text-muted-foreground">ID: {appointmentId}</span>
        )}
      </div>
      <Button
        size="sm"
        className="text-xs bg-amber-500 hover:bg-amber-600"
        onClick={onSave}
        disabled={isSaving || disableSave}
      >
        {isSaving ? t("common.saving", "Saving...") : t("common.save", "Save")}
      </Button>
    </div>
  )
}
